import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = (theme) => {
    return {
        contentBlock: {
            height: 36,
            paddingLeft: 0,
            paddingRight: 0,
        },
        labelText: {
            float: 'left',
            height: 36,
            lineHeight: '36px',
            marginLeft: 16,
            fontSize: 14,
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            cursor: 'default',
            '&$action': {
                fontSize: 12,
                fontStyle: 'italic',
                fontVariant: 'small-caps',
                textTransform: 'lowercase',
                color: theme.palette.secondary.main,
                cursor: 'pointer',
            },
            '&$status': {
                float: 'right',
                fontSize: 11,
                fontStyle: 'italic',
                fontVariant: 'small-caps',
                textTransform: 'uppercase',
                marginLeft: 0,
                marginRight: 16,
            }
        },
        action: {},
        status: {},
        controlGroup: {
            marginRight: 24,
            marginLeft: 24,
            marginBottom: 24,
        },
        control: {
            marginLeft: 16,
            marginRight: 0,
        }
    };
}

class InviteEntry extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showConfirm: false,
        };
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div>
                <div className={classes.contentBlock}>
                    {this._renderLabel()}
                    {this._renderLabelCaption()}
                    {this._renderStatus()}
                </div>
                <Divider/>
                {this._renderConfirmRemoveDialog()}
            </div>
        );
    }

    _renderLabel = () => {
        const {classes} = this.props;

        return (
            <Typography
                className={classes.labelText}
                align='left'
                variant='subtitle1'
            >
                {this.props.info.user_name}
            </Typography>
        );
    }

    _renderLabelCaption = () => {
        const {classes} = this.props;

        return (
            <Typography
                className={classNames(classes.labelText, classes.action)}
                align='left'
                variant='subtitle1'
                onClick={this._handleRemove}
            >
                remove
            </Typography>
        );
    }

    _renderStatus = () => {
        const {classes} = this.props;

        return (
            <Typography
                className={classNames(classes.labelText, classes.status)}
                align='right'
                variant='subtitle1'
            >
                Pending Accept
            </Typography>
        );
    }

    _renderConfirmRemoveDialog = () => {
        const {classes} = this.props;

        return (
            <div>
                <Dialog
                    fullWidth={true}
                    disableBackdropClick={false}
                    disableEscapeKeyDown={false}
                    open={this.state.showConfirm}
                    onBackdropClick={this._handleConfirmCancel}
                    onEscapeKeyDown={this._handleConfirmCancel}
                >
                    <DialogTitle>
                        Are you sure?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            This action will invalidate the invitation sent out previously. Are you sure?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className={classes.controlGroup}>
                        <Button
                            className={classes.control}
                            color='secondary'
                            autoFocus={true}
                            onClick={this._handleConfirmCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            className={classes.control}
                            color='secondary'
                            autoFocus={true}
                            variant='contained'
                            onClick={this._handleConfirmOk}
                        >
                            Remove
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

    _handleRemove = () => {
        this.setState({
            showConfirm: true,
        });
    }

    _handleConfirmOk = () => {
        this.setState({
            showConfirm: false,
        });

        if (this.props.onRemove) {
            this.props.onRemove(this.props.infoIndex);
        }
    }

    _handleConfirmCancel = () => {
        this.setState({
            showConfirm: false,
        });
    }
}

InviteEntry.propTypes = {
    info: PropTypes.object.isRequired,
    infoIndex: PropTypes.number.isRequired,
    onRemove: PropTypes.func,
}

export default withStyles(styles)(InviteEntry);
